import {
  ADD_VISITOR,
  BULK_CSV_UPLOAD,
  BULK_IMAGE_UPLOAD,
  BULK_VERIFY_VISITOR_LIST,
  BULK_VERIFY_VISIT_FORM,
  EDIT_UNVERIFYCSV_VISIT,
  EDIT_VISITOR,
  VERIFY_VISITOR_DETAIL,
  VISITOR_DETAIL,
  VISITOR_ERROR,
  VISITOR_FORM,
  VISITOR_FORM_UPDATE,
  VISITOR_LIST,
  VISITOR_STATUS_UPDATE,
  VISITOR_LISTS,
  CHECK_REFERENCE_EXIST
} from "reduxStore/types";
import {
  BULK_VISITOR_DETAIL,
  BULK_VISITOR_LIST,
  BULK_VISIT_FORM,
  REMOVE_VISITOR_MOBILE_CHECK,
  VISITOR_MOBILE_CHECK,
} from "../types";

const initialState = {
  response: {},
  loading: true,
  create: false,
  detail: false,
};
const initialStateForm = {
  response: null,
  update: false,
  response1:null
};
export default function visitorStore(state = initialState, action) {
  switch (action.type) {
    case VISITOR_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    case ADD_VISITOR:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    case EDIT_VISITOR:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    case VISITOR_DETAIL:
      return {
        ...state,
        loading: false,
        create: false,
        detail: true,
        response: action.payload,
      };
    case VISITOR_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    case BULK_IMAGE_UPLOAD:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    case BULK_CSV_UPLOAD:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    // New_Upload
    case BULK_VISITOR_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    case BULK_VISITOR_DETAIL:
      return {
        ...state,
        loading: false,
        create: false,
        detail: true,
        response: action.payload,
      };
    // Verify_Lead
    case BULK_VERIFY_VISITOR_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    case VISITOR_STATUS_UPDATE:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    case VERIFY_VISITOR_DETAIL:
      return {
        ...state,
        loading: false,
        create: false,
        detail: true,
        response: action.payload,
      };
    case EDIT_UNVERIFYCSV_VISIT:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
      case VISITOR_LISTS:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
// visitor
export function visitorFormReducer(state = initialStateForm, action) {
  switch (action.type) {
    case VISITOR_FORM:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    case VISITOR_FORM_UPDATE:
      return {
        ...state,
        update: true,
        response: action.payload,
      };

    default:
      return state;
  }
}
// Visitor_Mobile_number_check
export function visitorMobileCheckReducer(state = initialStateForm, action) {
  switch (action.type) {
    case VISITOR_MOBILE_CHECK:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    case REMOVE_VISITOR_MOBILE_CHECK:
      return {
        ...state,
        update: true,
        response: action.payload,
      };
      case CHECK_REFERENCE_EXIST:
      return {
        ...state,
        update: false,
        response1: action.payload,
      };

    default:
      return state;
  }
}

// Newupload_form
export function visitFormReducer(state = initialStateForm, action) {
  switch (action.type) {
    case BULK_VISIT_FORM:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
// Verify_lead_form
export function verifyVisitFormReducer(state = initialStateForm, action) {
  switch (action.type) {
    case BULK_VERIFY_VISIT_FORM:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
